import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CommonsUtils } from '../../commons/CommonsUtils';
import { INSURED_RELATIONSHIP_OPTIONS, normalizeRelationship } from '../../header-footer-template/model/InsuredDTO';
var InsuredModalComponent = /** @class */ (function () {
    function InsuredModalComponent(fb) {
        var _this = this;
        this.fb = fb;
        this.show = false;
        // Cuando se informa, el modal precarga sus datos y pasa a modo modificación.
        this.insured = null;
        // Pólizas DJ29 seleccionables al crear un asegurado. En modificación no se usa (la póliza
        // del asegurado no cambia).
        this.policies = [];
        this.closed = new EventEmitter();
        this.saved = new EventEmitter();
        this.relationships = INSURED_RELATIONSHIP_OPTIONS;
        this.prefixes = CommonsUtils.phonePrefix();
        this.submitted = false;
        this.running = false;
        this.form = this.fb.group({
            policySequence: ['', [Validators.required]],
            name: ['', [Validators.required]],
            firstSurname: ['', [Validators.required]],
            lastName: [''],
            documentNumber: ['', [Validators.required]],
            phonePrefix: [InsuredModalComponent.DEFAULT_PREFIX, [Validators.required]],
            phone: ['', [Validators.required, InsuredModalComponent.phoneValidator]],
            relationship: ['', [Validators.required]],
            birthDate: ['', [Validators.required, Validators.pattern('^[0-9]{2}/[0-9]{2}/[0-9]{4}$'),
                    InsuredModalComponent.adultValidator]],
            email: ['', [Validators.required, Validators.pattern(CommonsUtils.EMAIL_REGEX)]]
        });
        // La regla que se aplica al número depende del prefijo elegido, así que hay que
        // revalidarlo al cambiarlo; si no, el error se quedaría con el criterio del anterior.
        this.form.get('phonePrefix').valueChanges.subscribe(function () {
            _this.form.get('phone').updateValueAndValidity();
        });
    }
    /**
     * Con prefijo español se exigen los nueve dígitos de siempre; con cualquier otro no se
     * conoce la longitud del número, así que basta con que sean dígitos. Es el mismo criterio
     * que aplica el backend en InsuredSupplementValidationCoreCmd.
     */
    InsuredModalComponent.phoneValidator = function (control) {
        var value = control.value;
        if (!value) {
            return null;
        }
        var prefixControl = control.parent ? control.parent.get('phonePrefix') : null;
        var prefix = prefixControl ? prefixControl.value : InsuredModalComponent.DEFAULT_PREFIX;
        var pattern = (prefix === InsuredModalComponent.DEFAULT_PREFIX)
            ? /^[0-9]{9}$/
            : /^[0-9]{4,15}$/;
        return pattern.test(value) ? null : { pattern: true };
    };
    /**
     * Solo pueden asegurarse mayores de edad, así que se rechaza una fecha de nacimiento de
     * la que se deduzcan menos de 18 años. Se deja pasar lo que no le corresponde (vacío,
     * formato incorrecto o día inexistente): de eso ya avisan required y pattern.
     */
    InsuredModalComponent.adultValidator = function (control) {
        var value = control.value;
        if (!value || !/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(value)) {
            return null;
        }
        var parts = value.split('/');
        var day = Number(parts[0]);
        var month = Number(parts[1]);
        var year = Number(parts[2]);
        var birthDate = new Date(year, month - 1, day);
        if (birthDate.getFullYear() !== year || birthDate.getMonth() !== (month - 1) || birthDate.getDate() !== day) {
            return null;
        }
        // Es mayor de edad el mismo día que cumple los 18.
        var adultFrom = new Date(year + 18, month - 1, day);
        return (adultFrom > new Date()) ? { underage: true } : null;
    };
    Object.defineProperty(InsuredModalComponent.prototype, "isEditMode", {
        get: function () {
            return !!this.insured;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsuredModalComponent.prototype, "phoneMaxLength", {
        /** Un número español son 9 dígitos; con otro prefijo se deja margen para longitudes mayores. */
        get: function () {
            return this.isSpanishPrefix ? 9 : 15;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsuredModalComponent.prototype, "phoneErrorDescription", {
        get: function () {
            return this.isSpanishPrefix ? '(*) 9 dígitos sin espacios' : '(*) Solo dígitos, sin espacios';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsuredModalComponent.prototype, "isSpanishPrefix", {
        get: function () {
            return this.form.get('phonePrefix').value === InsuredModalComponent.DEFAULT_PREFIX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsuredModalComponent.prototype, "isPolicyFixed", {
        // La póliza no es editable en modificación ni cuando el usuario solo tiene una póliza DJ29
        // (se autorrellena); solo se muestra como combo al crear con varias pólizas.
        get: function () {
            return this.isEditMode || (this.policies && this.policies.length === 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsuredModalComponent.prototype, "selectedPolicyLabel", {
        get: function () {
            var seq = this.form.get('policySequence').value;
            var policy = (this.policies || []).find(function (p) { return String(p.sequence) === String(seq); });
            return policy ? policy.label : (seq !== null && seq !== undefined && seq !== '' ? String(seq) : '');
        },
        enumerable: true,
        configurable: true
    });
    InsuredModalComponent.prototype.resolveInitialPolicy = function () {
        if (this.isEditMode) {
            return this.insured ? this.insured.policySequence : '';
        }
        return (this.policies && this.policies.length === 1) ? this.policies[0].sequence : '';
    };
    InsuredModalComponent.prototype.ngOnChanges = function (changes) {
        if (changes.show && changes.show.currentValue === true) {
            // El listado de Innova ya devuelve la relación de parentesco (TITURELA), así que
            // en modo modificación ese campo se precarga como el resto.
            this.form.reset({
                policySequence: this.resolveInitialPolicy(),
                name: this.insured ? (this.insured.name || '') : '',
                firstSurname: this.insured ? (this.insured.firstSurname || '') : '',
                lastName: this.insured ? (this.insured.lastName || '') : '',
                documentNumber: this.insured ? (this.insured.documentNumber || '') : '',
                phonePrefix: (this.insured && this.insured.mobilePhonePrefix)
                    ? this.insured.mobilePhonePrefix
                    : InsuredModalComponent.DEFAULT_PREFIX,
                phone: this.insured ? (this.insured.mobilePhone || '') : '',
                relationship: this.insured ? normalizeRelationship(this.insured.relationship) : '',
                birthDate: this.insured ? (this.insured.bornDate || '') : '',
                email: this.insured ? (this.insured.email || '') : ''
            });
            this.submitted = false;
            this.running = false;
        }
    };
    InsuredModalComponent.prototype.isInvalid = function (name) {
        var c = this.form.get(name);
        return !!(c && c.invalid && (c.dirty || c.touched || this.submitted));
    };
    InsuredModalComponent.prototype.close = function () {
        if (this.running) {
            return;
        }
        this.closed.emit();
    };
    InsuredModalComponent.prototype.save = function () {
        this.submitted = true;
        if (this.form.invalid || this.running) {
            return;
        }
        this.running = true;
        var value = this.form.value;
        var dto = {
            name: value.name,
            firstSurname: value.firstSurname,
            lastName: value.lastName || '',
            documentNumber: value.documentNumber,
            phone: value.phone,
            phonePrefix: value.phonePrefix,
            relationship: value.relationship,
            bornDate: this.toIsoDate(value.birthDate),
            email: value.email || ''
        };
        this.saved.emit({ dto: dto, policySequence: Number(value.policySequence) });
    };
    /** Llamar desde el padre tras éxito/error para liberar el estado de envío. */
    InsuredModalComponent.prototype.setRunning = function (running) {
        this.running = running;
    };
    // El backend espera la fecha en formato ISO (yyyy-MM-dd) para InsuredSupplementDTO.bornDate;
    // el formulario la captura como dd/mm/yyyy.
    InsuredModalComponent.prototype.toIsoDate = function (ddMmYyyy) {
        var _a = ddMmYyyy.split('/'), day = _a[0], month = _a[1], year = _a[2];
        return year + "-" + month + "-" + day;
    };
    /** Prefijo preseleccionado al dar de alta, y el que se asume si Innova no devuelve ninguno. */
    InsuredModalComponent.DEFAULT_PREFIX = '34';
    return InsuredModalComponent;
}());
export { InsuredModalComponent };
